<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @openAddPlan="openAddPlan"
      @export="exportFile"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openAddPlan="openAddPlan"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <AddPlan
      v-if="addPlanOptions.visible"
      :visible.sync="addPlanOptions.visible"
      @close="close"
      @openEditPage="openEditPage"
      :disabled="addPlanOptions.disabled"
      :amzFlipOrderCode="addPlanOptions.amzFlipOrderCode"
    ></AddPlan>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          amzFlipOrderCode: chooseTemplateOptions.amzFlipOrderCode,
        },
      }"
       @export-success="() =>{}"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageMain from './main.vue'
import PageHeader from './header'
import AddPlan from '../add-plan'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/ecom/components/choose-template'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, AddPlan, chooseTemplate },

  data() {
    return {
      usePage: true,
      addPlanOptions: {
        visible: false,
        disabled: false,
        amzFlipOrderCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        amzFlipOrderCode: '',
        templateGroup: '',
      },
      table: [],
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFlipOrderListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportFile({ amzFlipOrderCode }, { templateGroup }) {
      this.chooseTemplateOptions = {
        visible: true,
        amzFlipOrderCode,
        templateGroup,
      }
    },
    openAddPlan({ pageType, amzFlipOrderCode }) {
      if (pageType == 'add') {
        this.addPlanOptions.disabled = false
      } else if (pageType == 'edit') {
        this.addPlanOptions.disabled = true
        this.addPlanOptions.amzFlipOrderCode = amzFlipOrderCode
      }
      this.addPlanOptions.visible = true
    },
    openEditPage({ pageType, data = {} }) {
      const { amzFlipOrderCode = '', amzFlipOrderNo = '' } = data
      let params = { pageType }
      let query = {}
      if (amzFlipOrderCode) params = { ...params, code: amzFlipOrderCode }
      if (amzFlipOrderNo) query = { ...query, amzFlipOrderNo: amzFlipOrderNo }
      this.$router.push({
        name: 'ecom-awsBiz-skuOrderMonitor-detail',
        params,
        query,
      })
    },
    close() {
      this.addPlanOptions.visible = false
      this.reload()
    },
  },
}
</script>
